import { Observable, Subscription } from 'rxjs';
import { QuestionBase } from './question-base';

/*
Sample:
new DropdownQuestion({
  key: 'brave',
  label: 'Bravery Rating',
  placeholder: 'Select option...',
  options: [
    {key: 'solid',  value: 'Solid'},
    {key: 'great',  value: 'Great'},
    {key: 'good',   value: 'Good'},
    {key: 'unproven', value: 'Unproven'}
  ],
  order: 8
})
*/
export class DropdownQuestion extends QuestionBase<string> {
  controlType = 'dropdown';
  options: { key: string; value: string; disabled: string; data?: any }[] = [];
  optionsObservable: Observable<any>;
  multiple: boolean;
  customEventHandlers: any = {};
  optionsSubscription: Subscription;
  placeholder: string;
  separator: boolean;

  constructor(options: {} = {}) {
    super({ ...options, designSystem: true });
    this.options = options['options'] || [];
    this.optionsObservable = options['optionsObservable'] || null;
    this.multiple = options['multiple'];
    this.placeholder = options['placeholder'] || 'actions.select';
    this.separator = options['separator'] || false;
    this.action = options['action'];

    this.setEventHandlers();

    if (this.optionsObservable) {
      this.optionsSubscription = this.optionsObservable.subscribe((opts) => this.setOptions(opts));
    }
  }

  onDeleteQuestion() {
    super.onDeleteQuestion();
    if (this.optionsSubscription) {
      this.optionsSubscription.unsubscribe();
    }
  }

  setOptions(opts) {
    this.options = opts.options;
  }

  setEventHandlers() {
    this.customEventHandlers = { ...this.eventHandlers };
    this.eventHandlers = {
      ...this.eventHandlers,
      onChange: (value) => this.onChange(value)
    };
  }

  onChange(value) {
    if (this.customEventHandlers.onChange) {
      this.customEventHandlers.onChange(value, this);
    }
    const data = this.getData(value);
    if (this.customEventHandlers.onSelected) {
      this.customEventHandlers.onSelected(data, this);
    }
    this.updateChildQuestions(data);
  }

  getData = (value: string): any => {
    const selectedOption = this.findOption(this.options, value);
    return selectedOption ? selectedOption.data : null;
  };

  findOption(options, key) {
    let found;
    options.forEach((option) => {
      if (!found) {
        if (option.key === key) {
          found = option;
        } else if (option.options) {
          found = this.findOption(option.options, key);
        }
      }
    });
    return found;
  }
}
